import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    t,
    getPath
  } = useLanguage();
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };
  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-121">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 sm:max-w-4xl sm:mx-auto z-50" data-id="element-122">
          <div className="rounded-2xl border shadow-2xl backdrop-blur-xl" style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--border)'
      }} data-id="element-123">
            {/* Mobile: Compact vertical layout */}
            <div className="sm:hidden p-5" data-id="element-124">
              <div className="flex items-start justify-between mb-4" data-id="element-125">
                <h3 className="text-base font-semibold" style={{
              color: 'var(--text-primary)'
            }} data-id="element-126">
                  🍪 {t('cookie.title')}
                </h3>
                <button onClick={handleDecline} className="p-1 rounded-lg transition-colors" style={{
              color: 'var(--text-muted)'
            }} aria-label="Close" data-id="element-127">
                  <XIcon className="w-4 h-4" data-id="element-128" />
                </button>
              </div>

              <p className="text-xs leading-relaxed mb-4" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-129">
                {t('cookie.description')}
              </p>

              <a href={getPath('privacy')} className="text-xs font-medium mb-4 inline-block hover:underline" style={{
            color: 'var(--accent)'
          }} data-id="element-130">
                {t('cookie.learnMore')} →
              </a>

              <div className="flex flex-col gap-2 mt-4" data-id="element-131">
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={handleAccept} className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-semibold text-xs transition-all" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-132">
                  <CheckIcon className="w-3 h-3" data-id="element-133" />
                  {t('cookie.accept')}
                </motion.button>

                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={handleDecline} className="px-4 py-2.5 rounded-lg font-semibold text-xs border transition-all" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-tertiary)',
              color: 'var(--text-primary)'
            }} data-id="element-134">
                  {t('cookie.decline')}
                </motion.button>
              </div>
            </div>

            {/* Desktop: Horizontal stretched layout */}
            <div className="hidden sm:flex items-center gap-6 p-6" data-id="element-135">
              <div className="flex-1" data-id="element-136">
                <h3 className="text-lg font-semibold mb-2" style={{
              color: 'var(--text-primary)'
            }} data-id="element-137">
                  🍪 {t('cookie.title')}
                </h3>
                <p className="text-sm leading-relaxed mb-2" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-138">
                  {t('cookie.description')}
                </p>
                <a href={getPath('privacy')} className="text-sm font-medium inline-block hover:underline" style={{
              color: 'var(--accent)'
            }} data-id="element-139">
                  {t('cookie.learnMore')} →
                </a>
              </div>

              <div className="flex items-center gap-3" data-id="element-140">
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={handleAccept} className="flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all whitespace-nowrap" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-141">
                  <CheckIcon className="w-4 h-4" data-id="element-142" />
                  {t('cookie.accept')}
                </motion.button>

                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={handleDecline} className="px-6 py-3 rounded-lg font-semibold text-sm border transition-all whitespace-nowrap" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-tertiary)',
              color: 'var(--text-primary)'
            }} data-id="element-143">
                  {t('cookie.decline')}
                </motion.button>

                <button onClick={handleDecline} className="p-2 rounded-lg transition-colors" style={{
              color: 'var(--text-muted)'
            }} aria-label="Close" data-id="element-144">
                  <XIcon className="w-5 h-5" data-id="element-145" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}